import { render } from "./CoachingEntries.vue?vue&type=template&id=028afb64&scoped=true"
import script from "./CoachingEntries.vue?vue&type=script&lang=js"
export * from "./CoachingEntries.vue?vue&type=script&lang=js"

import "./CoachingEntries.vue?vue&type=style&index=0&id=028afb64&scoped=true&lang=css"

import exportComponent from "/Users/rebecca/Workspace/repositories/mercator/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-028afb64"]])

export default __exports__